import React from 'react';
import Title from '../Shared/Title/Title';
import ReactPlayer from 'react-player/lazy';
import * as styles from './componentMedia.module.scss';
import { GatsbyImage } from 'gatsby-plugin-image';

const ComponentMedia = ({ data, spacedVideo }) => {
  const { youTubeUrl, tikTokVideoUrl, title, description, image, imageCaption, mobileImage } = data;
 console.log(mobileImage);
 
  return (
    <div className='container container-lg'>
      <div>
        {title &&<div className={styles.title}><Title title = {title} headingLevel = 'h3'/></div>}
        {description && <p className={styles.desc}>{description.description}</p>}
      </div>
        {image && <div className={styles.photo}>
            <GatsbyImage 
              image = {image.gatsbyImageData}
              objectFit = 'cover'
              loading='lazy'
              alt = {`${image.title} image`}
              />
          </div>
        }

        {mobileImage && <div className={styles.mobilePhoto}>
            <GatsbyImage 
              image = {mobileImage.gatsbyImageData}
              objectFit = 'cover'
              loading='lazy'
              alt = {`${mobileImage.title} image`}
              />
          </div>
        }
      {imageCaption && <p className={styles.imageCaption}> {imageCaption}</p>}
      <div className={spacedVideo ? styles.spacedWrapper:''}>
        {youTubeUrl && <div className={styles.videoWrapper}>
          <ReactPlayer
            url={youTubeUrl}
            width='100%'
            height='100%'
            playing={false}
            controls={true}
            muted={true}
            alt={"media player"}
          />
        </div>}
        {tikTokVideoUrl && <div className={styles.videoBg}>
          <iframe name="__tt_embed__v75200785883821900" sandbox="allow-popups allow-popups-to-escape-sandbox allow-scripts allow-top-navigation allow-same-origin" src={tikTokVideoUrl} style={{width: '100%', height: '739px', display: 'block', visibility: 'unset', zIndex: '100'}}></iframe>
        </div>}
      </div>
    </div>
  );
}
export default ComponentMedia